<template>
  <div>
    <breadcrumb :breadcrumb="breadcrumb" />
    <text-title :mainTitle="mainTitle" :subheading="subheading" />
    <form>
      <div class="form-line">
        <div class="textBox">
          <b class="red">*</b>
          <span class="line-text">授权人：</span>
        </div>
        <el-select v-model="formData.codeInResourcePerson"
                   filterable
                   remote
                   reserve-keyword
                   size="small" style="width: 280px"
                   :remote-method="remoteMethod"
                   placeholder="请输入关键词查询">
          <el-option v-for="item in responsiblePersonList" :key="item._value"
                     :label="item._label" :value="item._value">
          </el-option>
        </el-select>
      </div>

      <div class="form-line">
        <div class="textBox">
          <span class="line-text">备注：</span>
        </div>
        <el-input v-model="formData.memo" size="small" style="width: 280px" />
      </div>

      <div class="form-btn-box">
        <button-confirm @confirm="confirm" />
        <button-cancel @cancel="cancel" />
      </div>
    </form>
  </div>
</template>

<script>
  import md5 from 'js-md5'
  import Breadcrumb from '../../../../components/Breadcrumb/Breadcrumb'
  import TextTitle from '../../../../components/Text/TextTitle'
  import ButtonConfirm from '../../../../components/Button/ButtonConfirm'
  import ButtonCancel from '../../../../components/Button/ButtonCancel'
  import {errorHandler} from '../../../../utils/errorHandler'
  import {api} from '../../../api/ParkingService'
  import {nError, nSuccess} from '../../../../utils/notice'
  import {pattern} from '../../../../utils/regular'

  export default {
    components: {
      ButtonCancel,
      ButtonConfirm,
      TextTitle,
      Breadcrumb},
    name: 'free-code-author-modify',
    data () {
      return {
        breadcrumb: [{
          value: '智慧停车',
          name: 'parking-device-management'
        }, {
          value: '其他配置'
        }],
        mainTitle: '修改授权人',
        subheading: '',

        responsiblePersonList: [],
        formData: {
          code: '',
          name: '',
          phone: '',
          enterpriseName: '',
          codeInResourcePerson: '',
          memo: '',
        }
      }
    },
    created () {
      this.getParkingAccountByCode()
    },
    methods: {
      toMangePage () {
        this.$router.push({
          name: 'free-code-author'
        })
      },

      // 获取信息
      getParkingAccountByCode () {
        this.$axios.get(`${api.getOtherConfigAuthorizer}/${this.$route.params.id}`, {})
          .then(res => {
            if (res.data.retCode === 1) {
              let data = res.data.data
              this.formData = data
              this.remoteMethod()
            }
          })
          .catch(errorHandler('获取信息失败'))
      },

      remoteMethod (query) {
        this.getResponsiblePersonList(query)
      },

      // 查询责任人
      getResponsiblePersonList (searchKey) {
        this.$axios.post(api.getResponsiblePersonList, {
          searchKey: searchKey || ''
        })
          .then(res => {
            let list = res.data.data
            list.forEach(it => {
              it._value = it.code
              it._label = `${it.name} / ${it.phone} / ${it.enterpriseName}`
            })
            this.responsiblePersonList = list
          })
          .catch(errorHandler('查询失败'))
      },

      confirm () {
        if (!this.formData.codeInResourcePerson) {
          nError('请选择授权人')
          return false
        }
        this.responsiblePersonList.map(v => {
          if (v.code === this.formData.codeInResourcePerson) {
            this.formData.name = v.name
            this.formData.phone = v.phone
            this.formData.enterpriseName = v.enterpriseName
          }
        })
        this.$axios.post(api.updateOtherConfigAuthorizer, this.formData)
          .then(res => {
            if (res.data.retCode === 1) {
              nSuccess('修改成功')
              this.toMangePage()
            }
          })
          .catch(errorHandler('修改失败'))
      },
      cancel () {
        this.toMangePage()
      }
    },
  }
</script>

<style scoped>
  form {
    width: 90%;
    margin: 0 auto;
    text-align: left;
  }
  .red {
    color: #FF0000;
    vertical-align: -webkit-baseline-middle;
  }
  .form-line {
    margin: 20px 0;
  }
  .line-text{
    color: #48576a;
    font-size: 14px;
    margin-right: 10px;
  }
  .textBox {
    display: inline-block;
    width: 120px;
    text-align: right;
  }
  .form-btn-box {
    width: 530px;
    padding: 0 124px;
    margin-top: 40px;
    display: flex;
    justify-content: space-between;
  }
  .dialogLine {
    width: 60%;
    margin: 20px auto;
    display: flex;
    justify-content: center;
  }
  .dialogLine div {
    min-width: 80px;
    text-align: right;
    margin-right: 10px;
    line-height: 30px;
  }
</style>



// WEBPACK FOOTER //
// src/view/ParkingService/ParkingOtherConfig/FreeCodeAuthor/FreeCodeAuthorModify.vue